import { render, staticRenderFns } from "./yiJianFuKuan.vue?vue&type=template&id=0a8ec044&scoped=true&"
import script from "./yiJianFuKuan.vue?vue&type=script&lang=js&"
export * from "./yiJianFuKuan.vue?vue&type=script&lang=js&"
import style0 from "./yiJianFuKuan.vue?vue&type=style&index=0&id=0a8ec044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ec044",
  null
  
)

export default component.exports